module.exports = __webpack_public_path__ + "static/img/ai.f0bf544.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ai.png
// module id = UINo
// module chunks = 1